import React from "react";
import { FaBatteryHalf, FaSignal } from "react-icons/fa";
import { FiWifi } from "react-icons/fi";
import { LuCross } from "react-icons/lu";
import { RxHamburgerMenu } from "react-icons/rx";
import { BiSquare } from "react-icons/bi";
import { PiLessThan } from "react-icons/pi";
import { format } from "date-fns";

export default function MobileDesign({
  children,
  setStart,
  setIsActive,
  setSeconds,
}) {
  const formatedDate = format(new Date(), "hh:mm"); // formated date
  return (
    <div
      className=" d-flex   justify-content-center align-items-center flex-column w-100"
      style={{
        height: "95vh",
        overflow: "auto",
      }}
    >
      <div
        className="game-container  "
        style={{
          height: "85%",
          borderColor: "black",
          borderRadius: "40px",
          position: "relative",
          border: "20px solid black",
        }}
      >
        <div
          style={{
            height: "5%",
            backgroundColor: "rgba(0,0,0,0.3)",
            color: "white",
          }}
          className="d-flex pt-2 justify-content-between px-3
        "
        >
          <div className="d-flex gap-2  align-items-center fs-6 ">
            {formatedDate}
            <LuCross size={14} />
          </div>
          <div className="d-flex gap-2">
            <FiWifi /> <FaSignal />
            <FaBatteryHalf size={20} />
          </div>
        </div>
        <span
          className="bg-black   "
          style={{
            width: "40%",
            color: "black",
            position: "absolute",
            top: "25%",
            transform: "rotate(90deg)",
            right: "83.5%",
            zIndex: "-20",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          ...
        </span>
        <span
          className="bg-black   "
          style={{
            width: "20%",
            color: "black",
            position: "absolute",
            top: "25%",
            transform: "rotate(-90deg)",
            left: "93%",
            zIndex: "-20",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          ....{" "}
        </span>
        <span
          className="bg-black  w-25 "
          style={{
            color: "black",
            position: "absolute",
            top: "5px",
            zIndex: "",
            left: "50%",
            right: "50%",
            transform: "translate(-50%,-50%)",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          hey
        </span>
        <main className="" style={{ height: "90%" }}>
          {children}
        </main>
        <div
          className="d-flex  justify-content-between   align-items-center"
          onClick={() => {
            setStart(false);
            setSeconds(160);
            setIsActive(false);
          }}
          style={{
            paddingInline: "50px",
            height: "5%",
          }}
        >
          <RxHamburgerMenu
            className="hover:bg-dark"
            style={{
              transform: "rotate(90deg)",
            }}
          />
          <BiSquare />
          <PiLessThan />
        </div>
      </div>
      <span
        style={{
          width: "25%",
          height: "0.1%",
          borderRadius: "100px",
          background: "white",
          boxShadow: " 0px 3px 5px black",
          // opacity: "0.2",
        }}
      ></span>
    </div>
  );
}
